import { IAcademicRepository } from '../../domain/repositories/IAcademicRepository';
import { SubjectDTO } from '../dto/SubjectDTO';
import { AcademicMapper } from '../mappers/AcademicMapper';

export class GetSubjectsUseCase {
  constructor(private repository: IAcademicRepository) {}

  async execute(): Promise<SubjectDTO[]> {
    const subjects = await this.repository.getSubjects();
    return AcademicMapper.subjectToDTOList(subjects);
  }
}
